<div appPreventPullToRefresh>
    <ng-container [ngSwitch]="viewMode">
        <!-- NOT_LOGGED_IN View -->
        <div *ngSwitchCase="EnumViewMode.NOT_LOGGED_IN" translate="no" fxLayout="column" fxLayoutAlign="center center" style="padding-top:50px" fxLayoutGap="0px">
            <img style="width:130px; padding-bottom:30px" src="./assets/police_israel_logo.png" />
            <div fxLayout="row" fxLayoutGap="1px" fxLayoutAlign="center center">
                <mat-label style="font-size:2em">קוד כניסה</mat-label>
            </div>
            <br />
            <div fxLayout="row" fxLayoutGap="1px" fxLayoutAlign="center center">
                <mat-form-field appearance="outline" color="warn" *ngFor="let control of inputControls; let i = index" class="otp-form-field">
                    <input style="font-size:2em"
                           class="otp-input shake-input"
                           matInput
                           [disabled]="isDisabledLogin"
                           maxlength="1"
                           type="text"
                           (input)="onInput($event, i)"
                           (keyup)="onLoginCheck()"
                           (keydown.backspace)="onBackspace($event, i)"
                           [(ngModel)]="inputValues[i]"
                           #inputBox>
                </mat-form-field>
            </div>
            <div style="text-align:center">
                <div mat-dialog-actions style="justify-content:center">
                    <button mat-icon-button (click)="clearInputs()">
                        <mat-icon class="mat-icon-large">highlight_off</mat-icon>
                    </button>
                </div>
                <br />
            </div>
            <br /><br />
            <div fxLayout="column" fxLayoutAlign="center center" style="opacity:0.5">
                <mat-label style="padding-top:5px">נגזרת על פי נוהל מספר 02.220.202</mat-label>
            </div>
            <br /><br />
            <mat-label style="padding-top:5px; opacity:0.3">version {{ version }}</mat-label>
            <br />
            <button mat-button style="opacity:0.1" (click)="clearPwa()">clear settings</button>
            <br />
        </div>

        <!-- CHECKING_1 View -->
        <div *ngSwitchCase="EnumViewMode.CHECKING_1" translate="no" fxLayout="column" fxLayoutAlign="center center" style="padding-top:50px" fxLayoutGap="0px">
            <img style="height:130px; padding-bottom:30px" src="./assets/police_israel_logo.png" />
            <mat-label style="font-size: 1.7em; opacity: 0.6">
                [ זמן-אמת ]
            </mat-label>
            <br/>
            <mat-form-field appearance="fill" class="entry1 form-element field-wide">
                <mat-label class="entryPolice">שם פרטי</mat-label>
                <span matPrefix class="equipment-emoji" aria-label="user name" role="img">👤</span>
                <input (keyup)="checkStartCheckReady()"
                       [(ngModel)]="userName"
                       style="font-size:1.8em"
                       matInput type="text" name="SearchDualList" class="entryPolice form-control" autocomplete="off">
                <a (click)="userName=''; checkStartCheckReady()" matSuffix aria-label="Clear">
                    <mat-icon>close</mat-icon>
                </a>
            </mat-form-field>
            <mat-form-field appearance="fill" class="entry1 form-element field-wide">
                <mat-label class="entryPolice">מספר אישי</mat-label>
                <span matPrefix class="equipment-emoji" aria-label="badge number" role="img">🆔</span>
                <input (keyup)="checkStartCheckReady()"
                       [(ngModel)]="officerId"
                       style="font-size:1.8em"
                       inputrestriction="numbers"
                       matInput type="number" name="SearchDualList" class="entryPolice form-control" autocomplete="off">
                <a (click)="officerId=''; checkStartCheckReady()" matSuffix aria-label="Clear">
                    <mat-icon>close</mat-icon>
                </a>
            </mat-form-field>
            <div class="helpEquipment" fxLayout="column" fxLayoutAlign="center center">
                <button style="width:175px" [disabled]="startCheckDisabled" mat-raised-button color="warn" (click)="start()">המשך</button>
                <br /><br />
                <button mat-stroked-button style="width:175px" (click)="installPwa()">
                    הורדת האפליקציה
                    <mat-icon style="position:relative; left:-4px">get_app</mat-icon>
                </button>
                <br />
            </div>
            <br />
            <mat-label style="padding-top:5px; opacity:0.2">version {{ version }}</mat-label>
            <br />
            <button mat-button style="opacity:0.1" (click)="clearPwa()">clear settings</button>
        </div>
        <!-- CHECKING_2 View (Map) -->
        <div *ngSwitchCase="EnumViewMode.CHECKING_2">
            <mat-sidenav-container style="height: 100vh;">
                <mat-sidenav #sidenav mode="over" position="start">
                    <mat-form-field st appearance="outline" style="width: 200px; margin: 10px;">
                        <mat-label>שם חבר</mat-label>
                        <input matInput placeholder="חיפוש" style="text-align: right" [(ngModel)]="filter">
                        <button *ngIf="filter" matSuffix mat-icon-button aria-label="Clear" (click)="filter=''">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <div class="marker-list-container">
                            <mat-list>
                                <mat-list-item *ngFor="let marker of filteredMarkers"
                                               (click)="openMarkerDialog(marker, false)"
                                               style="cursor: pointer">
                                    {{ marker.name }}
                                </mat-list-item>
                            </mat-list>
                        </div>
                    </div>
                </mat-sidenav>

                <!-- Main Content -->
                <mat-sidenav-content>
                    <mat-toolbar color="primary" class="custom-toolbar">
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="toolbar-container">
                            <div fxLayout="row" fxLayoutAlign="start center" class="toolbar-left">
                                <button mat-icon-button (click)="sidenav.toggle()">
                                    <mat-icon>menu</mat-icon>
                                </button>
                                <span class="marker-count"> נוכחים ({{ markerPositions.length }})</span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="end center" class="toolbar-right" style="position: relative; top: 25px">
                                <mat-checkbox [(ngModel)]="markTargetMode" class="mark-checkbox">
                                    סמן אזור
                                </mat-checkbox>
                                <div fxLayout="row" fxLayoutAlign="center center" class="numeric-stepper">
                                    <mat-form-field appearance="outline" class="radius-input" style="position: relative; top: -15px">
                                        <input matInput type="number" [(ngModel)]="targetRadius" min="10" max="1000" step="10">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </mat-toolbar>

                    <div *ngIf="googleMapApiLoaded">
                        <google-map height="700px" width="100%" [center]="center" [zoom]="zoom"
                                    (mapClick)="mapClicked($event)" (mapMousemove)="move($event)" (mapRightclick)="removeLastMarker()">
                            <map-circle *ngFor="let target of targetAreas"
                                        [center]="{lat: target.lat, lng: target.lng}"
                                        [options]="{
                            strokeColor: 'red',
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: 'red',
                            fillOpacity: 0.35,
                            radius: target.radius
                          }">
                            </map-circle>

                            <map-marker *ngFor="let marker of markerPositions"
                                        [position]="{lat: marker.lat, lng: marker.lng}"
                                        [icon]="marker.icon"
                                        [label]="marker.label"
                                        (mapClick)="openMarkerDialog(marker, true)">
                            </map-marker>

                            <map-info-window></map-info-window>
                        </google-map>
                    </div>
                    <div *ngIf="error" style="color:red;">{{ error }}</div>
                    <div *ngIf="position">
                        <h3>Your Location</h3>
                        <p>Latitude: {{ position.coords.latitude }}</p>
                        <p>Longitude: {{ position.coords.longitude }}</p>
                    </div>
                    <div *ngIf="!position && !error">
                        <p>Retrieving your location...</p>
                    </div>
                </mat-sidenav-content>
            </mat-sidenav-container>
        </div>
    </ng-container>

    <ng-template #archiveModal let-data="markerSelected">
        <div class="archive-dialog-container" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
            <div class="archive-dialog-header" cdkDragHandle fxLayout="row" fxLayoutAlign="space-between center">
                <mat-label class="archive-dialog-title"> {{ markerSelected.name }} מתנדב פעיל</mat-label>
                <div class="archive-dialog-drag-icon">
                    <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                        <path d="M0 0h24v24H0z" fill="none"></path>
                    </svg>
                </div>
            </div>
            <div mat-dialog-content class="archive-dialog-content" fxLayout="column" fxLayoutGap="10px">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <mat-label class="archive-dialog-label">Latitude:</mat-label>
                    <span class="archive-dialog-value">{{ markerSelected.lat }}</span>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <mat-label class="archive-dialog-label">Longitude:</mat-label>
                    <span class="archive-dialog-value">{{ markerSelected.lng }}</span>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <mat-label class="archive-dialog-label">Last update:</mat-label>
                    <span class="archive-dialog-value" style="color: #888; margin-left: 5px;">
            {{ getTimeSince(markerSelected.lastUpdate) }} s
          </span>
                </div>
            </div>
        </div>
    </ng-template>
</div>
